(function () {
  'use strict';

  var configEl = document.getElementById('tambur-tracking-config');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var metaPixelId = config.metaPixelId || '';
  var ga4Id = config.ga4Id || '';
  var currency = config.currency || 'SEK';

  function moneyToMajor(amount) {
    var n = Number(amount);
    if (!isFinite(n)) return 0;
    return n / 100;
  }

  function trackMeta(eventName, params) {
    if (!metaPixelId || typeof window.fbq !== 'function') return;
    window.fbq('track', eventName, params || {});
  }

  function initGa4() {
    if (!ga4Id) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', ga4Id, { send_page_view: true });
  }

  function trackGa4(eventName, params) {
    if (!ga4Id || typeof window.gtag !== 'function') return;
    window.gtag('event', eventName, params || {});
  }

  function trackSearch(term, source, extra) {
    var q = String(term || '').trim();
    if (!q) return;

    var src = source || 'unknown';
    var params = { search_term: q, search_source: src };
    if (extra && typeof extra === 'object') {
      Object.keys(extra).forEach(function (key) {
        params[key] = extra[key];
      });
    }

    if (src === 'autocomplete') {
      try {
        var dedupeKey = 'tambur_search_ac:' + q.toLowerCase();
        if (sessionStorage.getItem(dedupeKey)) return;
        sessionStorage.setItem(dedupeKey, '1');
      } catch (e) { /* ignore */ }
    }

    trackMeta('Search', { search_string: q });
    trackGa4('search', params);
  }

  function markSearchNavigation(term, source, extra) {
    try {
      sessionStorage.setItem('tambur_search_nav', JSON.stringify({
        term: String(term || '').trim(),
        source: source || 'unknown',
        ts: Date.now()
      }));
    } catch (e) { /* ignore */ }
    trackSearch(term, source, extra);
  }

  window.tamburTrackSearch = trackSearch;
  window.tamburMarkSearchNavigation = markSearchNavigation;

  document.addEventListener('tambur:tracking:search', function (e) {
    var data = e.detail || {};
    trackSearch(data.search_term || data.term, data.search_source || data.source, data);
  });

  initGa4();

  if (config.pageType === 'product' && config.product) {
    var p = config.product;
    var value = moneyToMajor(p.price);
    trackMeta('ViewContent', {
      content_name: p.title,
      content_ids: [String(p.variantId)],
      content_type: 'product',
      value: value,
      currency: currency
    });
    trackGa4('view_item', {
      currency: currency,
      value: value,
      items: [{
        item_id: String(p.variantId),
        item_name: p.title,
        price: value,
        quantity: 1
      }]
    });
  }

  if (config.pageType === 'collection' && config.collection) {
    trackMeta('ViewCategory', {
      content_name: config.collection.title,
      content_type: 'product_group'
    });
    trackGa4('view_item_list', {
      item_list_name: config.collection.title
    });
  }

  if (config.pageType === 'search' && config.searchQuery) {
    var searchTerm = String(config.searchQuery).trim();
    var skipResultsPage = false;
    if (searchTerm) {
      try {
        var navRaw = sessionStorage.getItem('tambur_search_nav');
        if (navRaw) {
          var nav = JSON.parse(navRaw);
          if (
            nav &&
            nav.term === searchTerm &&
            Date.now() - (nav.ts || 0) < 60000
          ) {
            skipResultsPage = true;
          }
          sessionStorage.removeItem('tambur_search_nav');
        }
      } catch (e) { /* ignore */ }
    }
    if (!skipResultsPage && searchTerm) {
      trackSearch(searchTerm, 'results_page');
    }
  }

  document.addEventListener('tambur:tracking:add-to-cart', function (e) {
    var data = e.detail || {};
    var variantId = data.variant_id || data.id;
    var quantity = data.quantity || 1;
    var price = moneyToMajor(data.price);
    var title = data.product_title || data.title || '';
    var value = price * quantity;

    trackMeta('AddToCart', {
      content_name: title,
      content_ids: [String(variantId)],
      content_type: 'product',
      value: value,
      currency: currency
    });

    trackGa4('add_to_cart', {
      currency: currency,
      value: value,
      items: [{
        item_id: String(variantId),
        item_name: title,
        price: price,
        quantity: quantity
      }]
    });
    persistGaCartAttributes();
  });

  // Server-side GA4 purchase: cart attributes → order note_attributes → webhook.
  // No _ga cookie (no analytics consent) → do nothing. Never invent an id.
  // Never block checkout; never write other cart attributes.
  var gaAttrsSent = null;
  var gaAttrsInflight = null;

  function readCookie(name) {
    var prefix = name + '=';
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].replace(/^\s+/, '');
      if (part.indexOf(prefix) === 0) {
        try {
          return decodeURIComponent(part.slice(prefix.length));
        } catch (e) {
          return part.slice(prefix.length);
        }
      }
    }
    return '';
  }

  function readGaStreamCookie() {
    var preferred = ga4Id ? '_ga_' + String(ga4Id).replace(/^G-/, '') : '';
    var fallback = '';
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].replace(/^\s+/, '');
      var eq = part.indexOf('=');
      if (eq < 1) continue;
      var name = part.slice(0, eq);
      if (name.indexOf('_ga_') !== 0) continue;
      var value;
      try {
        value = decodeURIComponent(part.slice(eq + 1));
      } catch (e) {
        value = part.slice(eq + 1);
      }
      if (preferred && name === preferred) return value;
      if (!fallback) fallback = value;
    }
    return fallback;
  }

  function parseGaClientId(raw) {
    if (!raw) return '';
    var fields = String(raw).split('.');
    if (fields.length < 2) return '';
    return fields[fields.length - 2] + '.' + fields[fields.length - 1];
  }

  function parseGaSession(raw) {
    if (!raw) return null;
    var value = String(raw);
    if (value.indexOf('GS2') === 0) {
      var sidMatch = value.match(/(?:^|[.$])s(\d+)/);
      var sctMatch = value.match(/(?:^|[.$])o(\d+)/);
      if (!sidMatch) return null;
      var gs2 = { _ga_sid: sidMatch[1] };
      if (sctMatch) gs2._ga_sct = sctMatch[1];
      return gs2;
    }
    if (value.indexOf('GS1') === 0) {
      var fields = value.split('.');
      if (fields.length < 4 || !fields[2] || !fields[3]) return null;
      return { _ga_sid: fields[2], _ga_sct: fields[3] };
    }
    return null;
  }

  function readGaCartAttributes() {
    var clientId = parseGaClientId(readCookie('_ga'));
    if (!clientId) return null;
    var attrs = { _ga_cid: clientId };
    var session = parseGaSession(readGaStreamCookie());
    if (session) {
      if (session._ga_sid) attrs._ga_sid = session._ga_sid;
      if (session._ga_sct) attrs._ga_sct = session._ga_sct;
    }
    return attrs;
  }

  function gaAttrsUnchanged(current, next) {
    if (!current || !next) return false;
    if (current._ga_cid !== next._ga_cid) return false;
    if (next._ga_sid && current._ga_sid !== next._ga_sid) return false;
    if (next._ga_sct && current._ga_sct !== next._ga_sct) return false;
    return true;
  }

  function persistGaCartAttributes() {
    try {
      var attrs = readGaCartAttributes();
      if (!attrs) return;
      if (gaAttrsUnchanged(gaAttrsSent, attrs)) return;
      if (gaAttrsInflight) {
        gaAttrsInflight.then(function () { persistGaCartAttributes(); });
        return;
      }

      gaAttrsInflight = fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var current = (cart && cart.attributes) || {};
          if (gaAttrsUnchanged(current, attrs)) {
            gaAttrsSent = attrs;
            return;
          }
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          }).then(function (res) {
            if (res.ok) gaAttrsSent = attrs;
          });
        })
        .catch(function () { /* attribution only — never block shopping */ })
        .then(function () { gaAttrsInflight = null; });
    } catch (e) {
      gaAttrsInflight = null;
    }
  }

  function isCheckoutLink(el) {
    if (!el || el.tagName !== 'A') return false;
    var href = (el.getAttribute('href') || '').trim();
    return href === '/checkout' || href.indexOf('/checkout?') === 0;
  }

  function isCheckoutSubmit(el) {
    if (!el) return false;
    return (el.tagName === 'BUTTON' || el.tagName === 'INPUT') && el.getAttribute('name') === 'checkout';
  }

  document.addEventListener('click', function (e) {
    var target = e.target && e.target.closest ? e.target.closest('a[href], button, input') : null;
    if (isCheckoutLink(target) || isCheckoutSubmit(target)) persistGaCartAttributes();
  }, true);

  document.addEventListener('submit', function (e) {
    var submitter = e.submitter;
    if (submitter && submitter.name === 'checkout') persistGaCartAttributes();
  }, true);
})();
